import axios, { AxiosInstance, AxiosError } from 'axios';

// Vite exposes env variables with VITE_ prefix
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://donasi.limabaik89.org';

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Don't send credentials for cross-origin requests
  withCredentials: false,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log(`[API Request] ${config.method?.toUpperCase()} ${config.url} - Has token: ${!!token}`);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(`[API Request] Authorization header set: Bearer ${token.substring(0, 20)}...`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    if (import.meta.env.DEV) {
      console.log(`[API Success] ${response.config.method?.toUpperCase()} ${response.config.url}`, response.status);
    }
    return response;
  },
  (error: AxiosError) => {
    const isLoginPage = window.location.pathname === '/login' || window.location.pathname.includes('/login');
    
    // Log errors in development
    if (import.meta.env.DEV) {
      console.error(`[API Error] ${error.config?.method?.toUpperCase()} ${error.config?.url}`, error.response?.status, error.response?.data);
      console.error('[API Error] Path:', window.location.pathname, 'IsLogin:', isLoginPage);
    }
    
    // Only redirect on 401 if not already on login page
    if (error.response?.status === 401 && !isLoginPage) {
      console.error('[Auth] 401 received, redirecting to login');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
